import * as moment from "moment";

export class CommonFunctions {
    public static sum(a: number, b: number): number {
        return a + b;
    }

    public static base64ToFile(data: any, filename: any) {

        const arr = data.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        let u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    }

    public static getPrivileges() {
        return JSON.parse(localStorage.getItem("privileges") || '[]');
    }

    public static setPrivileges(privileges: any) {
        localStorage.setItem('privileges', JSON.stringify(privileges));
    }

    public static getUserId(): string {
        const json = JSON.parse(localStorage.getItem('user') || '{}');
        return json.id;
    }

    public static getUser() {
        return JSON.parse(localStorage.getItem('user') || '{}');
    }

    public static getToken() {
        return localStorage.getItem("token") || '';
    }

    public static setUser(user: any) {
        localStorage.setItem('user', JSON.stringify(user));
    }

    public static setToken(token: any) {
        localStorage.setItem('token', token);
    }

    public static setTokenOfBusiness(token: any) {
        localStorage.setItem('sys_biz_token', token);
    }

    public static getTokenOfBusiness() {
        return localStorage.getItem("sys_biz_token") || '';
    }

    public static removeTokenOfBusiness() {
        localStorage.removeItem('sys_biz_token');
    }

    public static removeToken() {
        localStorage.removeItem('token');
    }

    public static removeUser() {
        localStorage.removeItem('user');
    }

    public static getTimeAndDateTag(timestamp: any, from: string) {
        // Mongo REST timestamps arrive as ISO-8601 strings, not Firestore Timestamp objects —
        // no .toDate() to call. new Date() parses an ISO string directly.
        const date = new Date(timestamp);
        let timeTag = '';
        if (this.isToday(date)) {
            timeTag = from == 'sidebar' ? moment(date).format("hh:mm A") : 'Today';
        } else if (this.isYesterday(date)) {
            timeTag = 'Yesterday';
        } else {
            timeTag = from == 'sidebar' ? moment(date).format("MM/DD/YYYY") : moment(date).format('dddd, MMM DD, YYYY');
        }
        return timeTag;
    }

    public static isToday(someDate: any) {
        const today = new Date()
        return someDate.getDate() == today.getDate() &&
            someDate.getMonth() == today.getMonth() &&
            someDate.getFullYear() == today.getFullYear()
    }


    public static isYesterday(someDate: any) {
        const today = new Date()
        return someDate.getDate() == today.getDate() - 1 &&
            someDate.getMonth() == today.getMonth() &&
            someDate.getFullYear() == today.getFullYear()
    }

    public static formatBytes(bytes: any, decimals = 2) {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }
}